import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

export default function SimpleMenu(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleItemClick = (e) => {
      let id = e.target.id;
      props.retButtonStyle(id);

  }

  return (
    <div>
      <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
        Color de texto
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem id="style1" onClick={handleItemClick}>Blanco</MenuItem>
        <MenuItem id="style2" onClick={handleItemClick}>Negro</MenuItem>
        {/* <MenuItem id="style3" onClick={handleItemClick}>Blanco</MenuItem>
        <MenuItem id="style4" onClick={handleItemClick}>Negro</MenuItem> */}
      </Menu>
    </div>
  );
}
